
const credentialStatusColors = {
    verifying: '#e65100',
    educator: '#212121',
    rejected: '#b71c1c',
    verified: '#1b5e20'
};

export default credentialStatusColors;